var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavefilesucess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 49L44.9167 57.1667L61.25 40.8333M85.75 49C85.75 53.8261 84.7994 58.6049 82.9526 63.0636C81.1057 67.5223 78.3987 71.5736 74.9862 74.9862C71.5736 78.3987 67.5223 81.1057 63.0636 82.9526C58.6049 84.7994 53.8261 85.75 49 85.75C44.1739 85.75 39.3951 84.7994 34.9364 82.9526C30.4777 81.1057 26.4264 78.3987 23.0138 74.9862C19.6013 71.5736 16.8943 67.5223 15.0474 63.0636C13.2006 58.6049 12.25 53.8261 12.25 49C12.25 39.2533 16.1219 29.9058 23.0138 23.0138C29.9058 16.1219 39.2533 12.25 49 12.25C58.7467 12.25 68.0942 16.1219 74.9862 23.0138C81.8781 29.9058 85.75 39.2533 85.75 49Z",
    stroke: "#15CE9A",
    strokeWidth: 8.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavefilesucess);
export default __webpack_public_path__ + "static/media/savefilesucess.926a9cefbb20527ea469069b4841d78f.svg";
export { ForwardRef as ReactComponent };